import { render, staticRenderFns } from "./CookieModal.vue?vue&type=template&id=5e81ab90&scoped=true&"
import script from "./CookieModal.vue?vue&type=script&lang=js&"
export * from "./CookieModal.vue?vue&type=script&lang=js&"
import style0 from "./CookieModal.vue?vue&type=style&index=0&id=5e81ab90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e81ab90",
  null
  
)

export default component.exports